import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import * as moment from 'moment';
import { bookingFormCommon } from './c005-bookingform-common';
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";
import { wcagOptions } from "./wcag";
import * as Cookies from 'js-cookie';

export class checkInForm {
	private $checkinError:Array<string> = [];
	private wcag = new wcagOptions();
	private bcommon = new bookingFormCommon();

	$scope: any = $('#check-in--container');
	$scopeMob: any = $('#mob-checkin--container');

	$bookRefContainer: any = $('.booking-ref--container');
	$eTicketContainer: any = $('.eticket-nos--container');

	
	nav(): void {
		let _self = this;
		let bcommon = _self.bcommon;
        let $scopeCheckinMob: any = $('#mob-checkin--container');
		let $bookFlight: any = $('#book-flight--container');
		let $viewBooking: any = $('#view-booking--container');
		let $flightStatus: any = $('#flight-status--container');
		let $mhStay: any = $('#ibe-stay--container');
		let $mhUpgrade: any = $('#mhupgrade-in--container');
		let $login: any = $('#login-container');
		let $loggedin:any = $('#logged-in-user-menu');
		let $bookFlightMob: any = $('#mobile-bookflight--container');
		let $viewBookingMob: any = $('#mob-viewbooking--container');
		let $flightStatusMob: any = $('#mob-flightstatus--container');
		let $mhStayMob: any = $('#mob-stay--container');
		let $mhUpgradeMob: any = $('#mob-mhupgrade--container');
		let $loginMob: any = $('#mob-login--container');
	  	let $loggedinMob: any = $('#mob-logged-in-user-menu');		
		let $mobMholidays  : any = $('#mobile-mholidays--container');
		let $mhHolidays : any = $('#mholiday-ibe--container');  
		let $flightUpgrade : any = $('#view-upgrade');
		let $flightupgradeMob: any 	 = $('#mob-flightupgrade--container');
		let $moreLinks: any 	 = $('#more-links--container');
		let $enrichMobChecking: any = $('.enrich-revamp .mob-check-in');
		let $moreLinksMob: any 	 = $('#mob-more-links--container');
		let $enrichHotelsMob: any 	 = $('#mobile-enrichhotels--container');
		let $enrichHotels: any 	 = $('#enrich-hotels-container');

		let $checkInRefSel:any             =   $('.checkin-refno--departure');
		let $checkeTicketSel:any           =   $('.checkin-eticket--departure');
		let $checkInRefSelectize:any       =   $checkInRefSel.parent().find('.selectize-control .selectize-input');
		let $checkeTicketSelectize:any     =   $checkeTicketSel.parent().find('.selectize-control .selectize-input');

		let $errorValidationGen:any     = $('.checkin-bookingref--error---validation');
		let $errorValidationEticketGen:any     = $('.checkin-eticketnos--error---validation');

		let $bookingFormTitle:any       = $('.booking-form--title');
		let $nameValidatorGen:any       = $('.name-validator');
		let $numValidatorGen:any        = $('.num-validator');
		let $couponCodeGen:any          = $('.couponCode');
		let $redemptionLogin:any        = $('.redemption-login .form-group');

		let $mabHeader:any  = $('#mab-header');
		let $ibeNavList: any = $('#bookingNav li');
		let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');
		let $navOverlay: any = $('.mab-nav--overlay');
		let $ibeNav: any;
		if($('.ibe-refresh').length >0) {
			$ibeNav = $('.desktop #bookingNav');
		}
		else {
			$ibeNav = $('#bookingNav');
		}		
		let $moreLinksCheckin = $('#more-links--container .check-in');

		// IBE Navigation show/hide Check in container
		$ibeNav.find('.check-in').on('click', () => {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:top-nav-check-in',
                'componentType': 'tab',
                'componentName': 'Check in Top Menu',
                'componentID': '',
				'attributes': []
            });
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.check-in').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
			}
			_self.$scope.show();
			$bookFlight.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$flightUpgrade.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$moreLinks.hide();
			$login.hide();
			$mhHolidays.hide();
			$loggedin.addClass('hidden');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$errorValidationEticketGen.hide();
			$enrichHotelsMob.hide();
			$enrichHotels.hide();
			$bookingFormTitle.removeClass('has-error');
			$nameValidatorGen.removeClass('has-error');
			$numValidatorGen.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
			$checkInRefSelectize.removeClass('has-error');
			$checkeTicketSelectize.removeClass('has-error');
			// let bookOptionVal = _self.$scope.find('input[name="book_opt"]:checked').val();
			// 	if(bookOptionVal == 'check_in'){
			// 		_self.$scope.find('#view-booking--container').hide();
			// 		_self.$scope.find('.view-booking--containertab').hide();
			// 		_self.$scope.find('.check-in--containertab').show();
			// 		_self.$scope.find('#view-nfs--container').hide();
			// 	}else if(bookOptionVal == 'neighbour-seat'){
			// 		_self.$scope.find('#view-booking--container').hide();
			// 		_self.$scope.find('.view-booking--containertab').show();
			// 		_self.$scope.find('.check-in--containertab').hide();
			// 		_self.$scope.find('#view-nfs--container').show();	
			// 	}
			// 	else{
			// 		_self.$scope.find('#view-nfs--container').hide();
			// 		_self.$scope.find('.check-in--containertab').hide();
			// 		_self.$scope.find('.view-booking--containertab').show();
			// 		_self.$scope.find('#view-booking--container').show();
			// 	}
			
							
		});
		$moreLinksCheckin.on('click', () => {
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.check-in').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
			}
			_self.$scope.show();
			$bookFlight.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$flightUpgrade.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$moreLinks.hide();
			$login.hide();
			$mhHolidays.hide();
			$loggedin.addClass('hidden');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$errorValidationEticketGen.hide();
			$enrichHotelsMob.hide();
			$enrichHotels.hide();
			$bookingFormTitle.removeClass('has-error');
			$nameValidatorGen.removeClass('has-error');
			$numValidatorGen.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
			$checkInRefSelectize.removeClass('has-error');
			$checkeTicketSelectize.removeClass('has-error');
			// let bookOptionVal = _self.$scope.find('input[name="book_opt"]:checked').val();
			// 	if(bookOptionVal == 'check_in'){
			// 		_self.$scope.find('#view-booking--container').hide();
			// 		_self.$scope.find('.view-booking--containertab').hide();
			// 		_self.$scope.find('.check-in--containertab').show();
			// 		_self.$scope.find('#view-nfs--container').hide();
			// 	}else if(bookOptionVal == 'neighbour-seat'){
			// 		_self.$scope.find('#view-booking--container').hide();
			// 		_self.$scope.find('.view-booking--containertab').show();
			// 		_self.$scope.find('.check-in--containertab').hide();
			// 		_self.$scope.find('#view-nfs--container').show();	
			// 	}
			// 	else{
			// 		_self.$scope.find('#view-nfs--container').hide();
			// 		_self.$scope.find('.check-in--containertab').hide();
			// 		_self.$scope.find('.view-booking--containertab').show();
			// 		_self.$scope.find('#view-booking--container').show();
			// 	}
			
							
		});


		// IBE Navigation show/hide Mobile Check in container
		$mobIbeNav.find('.mobile-check-in').on('click', () => {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:top-nav-check-in',
                'componentType': 'tab',
                'componentName': 'Check in Top Menu',
                'componentID': '',
				'attributes': []
            });
			checkinProcess();
		});
		$enrichMobChecking.on('click', () => {
			checkinProcess();
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header').addClass('hide');	
				$('.enrich-revamp .enrich-mobile-ibe-container').removeClass('hide');			
				let targetHeight: any = $(window).innerHeight() + 'px';
				$('.enrich-revamp #mob-checkin--container').css('height', targetHeight);					
			}
		});
		function checkinProcess() {
			let $checkInRefSelMob:any          =   $('.mobCheckin-refno--departure');
			let $checkeTicketSelMob:any        =   $('.mobCheckin-eticket--departure');
			let $checkInRefSelectizeMob:any    =   $checkInRefSelMob.parent().find('.selectize-control .selectize-input');
		    let $checkeTicketSelectizeMob:any  =   $checkeTicketSelMob.parent().find('.selectize-control .selectize-input');
			$('#bookingNav li').removeClass('selected');
			$mobIbeNav.find('.mobile-check-in').parent().addClass('selected');
			_self.$scopeMob.find('.booking-refno').parent().addClass('selected');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$flightupgradeMob.hide();
			$mobMholidays.hide();			
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$moreLinksMob.hide();
			$errorValidationGen.hide();
			$errorValidationEticketGen.hide();
			$enrichHotelsMob.hide();
			$bookingFormTitle.removeClass('has-error');
			$nameValidatorGen.removeClass('has-error');
			$numValidatorGen.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
			$checkInRefSelectizeMob.removeClass('has-error');
			$checkeTicketSelectizeMob.removeClass('has-error');
			bcommon.scrollToTopIBE();
			//mob-nfs--container
			// let bookOptionVal = _self.$scopeMob.find('input[name="mob_book_opt"]:checked').val();
			// if(bookOptionVal == 'check_in'){
			// 	_self.$scopeMob.find('#mob-viewbooking--container').hide();
			// 	_self.$scopeMob.find('.mob-view-booking--containertab').hide();
			// 	_self.$scopeMob.find('.mob-check-in--containertab').show();
			// 	_self.$scopeMob.find('#mob-nfs--container').hide();	
			// }else if(bookOptionVal == 'neighbour-seat'){
			// 	_self.$scopeMob.find('.mob-check-in--containertab').hide();
			// 	_self.$scopeMob.find('.mob-view-booking--containertab').show();
			// 	_self.$scopeMob.find('#mob-viewbooking--container').hide();
			// 	_self.$scopeMob.find('#mob-nfs--container').show();	
			// }
			// else{
			// 	_self.$scopeMob.find('.mob-check-in--containertab').hide();
			// 	_self.$scopeMob.find('.mob-view-booking--containertab').show();
			// 	_self.$scopeMob.find('#mob-viewbooking--container').show();
			// 	_self.$scopeMob.find('#mob-nfs--container').hide();	
			// }
		}



		// Overlay container - IBE Navigation show/hide Mobile Check in container
		$navOverlay.find('.mobile-check-in').on('click', () =>{
			let $checkInRefSelMob:any          =   $('.mobCheckin-refno--departure');
			let $checkeTicketSelMob:any        =   $('.mobCheckin-eticket--departure');
			let $checkInRefSelectizeMob:any    =   $checkInRefSelMob.parent().find('.selectize-control .selectize-input');
			let $checkeTicketSelectizeMob:any  =   $checkeTicketSelMob.parent().find('.selectize-control .selectize-input');

			$ibeNavList.removeClass('selected');
			$mobIbeNav.find('.mobile-check-in').parent().addClass('selected');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$flightupgradeMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mobMholidays.hide();
			$errorValidationGen.hide();
			$errorValidationEticketGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$nameValidatorGen.removeClass('has-error');
			$numValidatorGen.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
			$checkInRefSelectizeMob.removeClass('has-error');
			$checkeTicketSelectizeMob.removeClass('has-error');
			bcommon.scrollToTopIBE();
			// $scopeCheckinMob.find("input[name='mob_book_opt']").filter('[value=check_in]').prop('checked', true);
		    // $scopeCheckinMob.find('.mob-check-in--containertab').show();
			

			if (window.innerWidth > 767 && window.innerWidth < 1200) {								
				$ibeNav.find('li').removeClass('selected');
				$ibeNav.find('.check-in').parent().addClass('selected');
				_self.$scope.show();
				$bookFlight.hide();
				$viewBooking.hide();				
				$flightStatus.hide();
				$mhStay.hide();
				$mhUpgrade.hide();
				$login.hide();
				$mhHolidays.hide();
				$loggedin.addClass('hidden');
				$viewBookingMob.hide();
				$flightStatusMob.hide();
				$mhStayMob.hide();
				$mhUpgradeMob.hide();
				$loginMob.hide();
				$loggedinMob.hide();
				$errorValidationGen.hide();
				$errorValidationEticketGen.hide();
				$bookingFormTitle.removeClass('has-error');
				$nameValidatorGen.removeClass('has-error');
				$numValidatorGen.removeClass('has-error');
				$couponCodeGen.removeClass('has-error');
				$redemptionLogin.removeClass('has-error');
				$checkInRefSelectize.removeClass('has-error');
				$checkeTicketSelectize.removeClass('has-error');

				// let bookOptionVal = _self.$scope.find("input[name='book_opt']").filter('[value=check_in]').prop('checked', true);
				// _self.$scope.find('#view-booking--container').hide();
				// _self.$scope.find('.view-booking--containertab').hide();
				// _self.$scope.find('.check-in--containertab').show();
				// _self.$scope.find('#mob-nfs--container').hide();	
			}


	});
	

		// Check whether webcheckin=true

		if (window.location.search.indexOf('checkin=true') > -1) {
			let $container:any = $('.container');
			let $slideNav:any = $('#mab-bookingnav .navbar.navbar-default');
			let $iBENavigation:any = $('#mab-bookingnav');
			$container.hide();
			$slideNav.hide();
			$bookFlight.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$login.hide();
			$bookFlightMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$iBENavigation.css('background', '#fff');
			$iBENavigation.parent().show();
			$iBENavigation.find('.container').show();
			$('#mab-bookingnav.mobile').find('.container').show();
			$('#mab-bookingnav.mobile .navbar.navbar-default').show();
			$('#mab-bookingnav.mobile .nav.navbar-nav').hide();
			$('#mab-bookingnav.mobile .navbar.navbar-default').css('min-height', 0);
			_self.$scopeMob.addClass('webCheckin');
			_self.$scope.show();
			_self.$scopeMob.show();
		}
	}
	init(): void { 
		let _self = this;

			let bookOptionTab = _self.$scope.find('input[name="book_opt"]');
			let mobbookOptionTab = _self.$scopeMob.find('input[name="mob_book_opt"]');
			

			bookOptionTab.click(function(){
				let bookOptionVal = _self.$scope.find('input[name="book_opt"]:checked').val();
				if(bookOptionVal == 'check_in'){
					_self.$scope.find('#view-booking--container').hide();
					_self.$scope.find('.view-booking--containertab').hide();
					_self.$scope.find('.check-in--containertab').show();
					_self.$scope.find('#view-nfs--container').hide();
				}else if(bookOptionVal == 'neighbour-seat'){
					_self.$scope.find('#view-booking--container').hide();
					_self.$scope.find('.view-booking--containertab').show();
					_self.$scope.find('.check-in--containertab').hide();
					_self.$scope.find('#view-nfs--container').show();	
				}
				else{
					_self.$scope.find('#view-nfs--container').hide();
					_self.$scope.find('.check-in--containertab').hide();
					_self.$scope.find('.view-booking--containertab').show();
					_self.$scope.find('#view-booking--container').show();
				}
			});

			mobbookOptionTab.click(function(){
				let bookOptionVal = _self.$scopeMob.find('input[name="mob_book_opt"]:checked').val();
				if(bookOptionVal == 'check_in'){
					_self.$scopeMob.find('#mob-viewbooking--container').hide();
					_self.$scopeMob.find('.mob-view-booking--containertab').hide();
					_self.$scopeMob.find('.mob-check-in--containertab').show();
					_self.$scopeMob.find('#mob-nfs--container').hide();	
				}else if(bookOptionVal == 'neighbour-seat'){
					_self.$scopeMob.find('.mob-check-in--containertab').hide();
					_self.$scopeMob.find('.mob-view-booking--containertab').show();
					_self.$scopeMob.find('#mob-viewbooking--container').hide();
					_self.$scopeMob.find('#mob-nfs--container').show();	
				}
				else{
					_self.$scopeMob.find('.mob-check-in--containertab').hide();
					_self.$scopeMob.find('.mob-view-booking--containertab').show();
					_self.$scopeMob.find('#mob-viewbooking--container').show();
					_self.$scopeMob.find('#mob-nfs--container').hide();	
				}
			});
	}
	// Check-in IBE - Booking Reference no.
	checkinBookRefNo(): void {
		let _self = this;

		let $checkInBookRefSubmitBtn: any = $('.checkInBookRefSubmit');
		let $mobCheckInBookRefSubmitBtn: any = $('.mobcheckin-ref--btn');
		let numberPattern = /^\d+$/;
		let eticketNumberPattern = /^\d{3}-\d{10}$/;

		$('.booking-refno').click(() =>{
			_self.$bookRefContainer.show();
			_self.$eTicketContainer.hide();
			_self.$scope.find('.checkin-list li').removeClass('selected');
			_self.$scope.find('.booking-refno').parent().addClass('selected');
		});

		$('#mob-checkin--container .booking-refno').click(() =>{
			_self.$bookRefContainer.show();
			_self.$eTicketContainer.hide();
			_self.$scopeMob.find('.checkin-list li').removeClass('selected');
			_self.$scopeMob.find('.booking-refno').parent().addClass('selected');
		});

		let $checkInBookRefNo: any = $('.check-in--refno');
		let $checkInBookRefLastName: any = $('.checkin-refno--lastname');
		let $checkInRefnoDeparture: any = $('.checkin-refno--departure');
		let $checkInBookrefDate: any = $('.checkin-bookref--date');
		let ticketNoLimits = [6,14];
		$checkInRefnoDeparture.parent().addClass('disableEle');
		$checkInBookrefDate.parent().addClass('disableEle');

		let $mobCheckInBookRefNo: any = $('.mobcheck-in--refno');
		let $mobCheckInBookRefLastName: any = $('.mobcheckin-refno--lastname');
		let $mobCheckInRefnoDeparture: any = $('.mobCheckin-refno--departure');
		let $mobCheckInBookRefDate: any = $('.mobCheckin-bookref--date');
		$mobCheckInRefnoDeparture.parent().addClass('disableEle');
		$mobCheckInBookRefDate.parent().addClass('disableEle');

		//Check-in Booking reference Submit Button
		$checkInBookRefSubmitBtn.click((evt:any) => {
			let _self = this;
			evt.preventDefault();
			adobeDataLayer.push('click', {
                'clickName': 'click:btn-click:check-in-submit',
                'componentType': 'btn',
                'componentName': 'Check In Submit',
                'componentID': '',
				'attributes': []
            });
			let $validationSuccess    : any = true;
			let $checkinBookrefErrorValidation: any = $('.checkin-bookingref--error---validation');
			let $checkInBookRefPOD: any = $('.checkin-refno--departure');
			let $checkInBookRefNo: any = $('#check-in--container .check-in--refno');
			let $checkInBookRefLastName: any = $('.checkin-refno--lastname');
			let $checkInBookRefValidator : any = $('.checkinRefNo-validator');
			_self.$checkinError = [];
			$checkinBookrefErrorValidation.show();

			/** validate Booking Ref no. */
			let checkInBookRefNoVal = $checkInBookRefNo.val().trim();

			if(!$checkInBookRefNo.parent().hasClass('disableEle')){				
				if(checkInBookRefNoVal == '') {
					let $checkInBookRefNoValidate:any = $checkInBookRefNo.attr('data-bookrefno');
					_self.$checkinError.push('<strong>'+$checkInBookRefNo.parent().find('label').text()+':</strong> '+$checkInBookRefNoValidate);
					$checkInBookRefNo.addClass('has-error');
					$checkInBookRefNo.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else if (
					!ticketNoLimits.includes(checkInBookRefNoVal.length) 
						|| (checkInBookRefNoVal.length == 14 && !eticketNumberPattern.test(checkInBookRefNoVal))						
				) {
					let $checkInBookRefNoValidate:any = $checkInBookRefNo.attr('data-eticketnolen');
					_self.$checkinError.push('<strong>'+$checkInBookRefNo.parent().find('label').text()+':</strong> '+$checkInBookRefNoValidate);
					$checkInBookRefNo.addClass('has-error');
					$checkInBookRefNo.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else {
					$checkInBookRefNo.removeClass('has-error');
					$checkInBookRefNo.parent().find('.booking-form--title').removeClass('has-error');
				}

				/** validate Booking Last Name */
				if($checkInBookRefLastName.val() == ''){
					let $checkInBookRefLastNameValidate:any = $checkInBookRefLastName.attr('data-checkinlastname');
					_self.$checkinError.push('<strong>'+$checkInBookRefLastName.parent().find('label').text()+':</strong> '+$checkInBookRefLastNameValidate);
					$checkInBookRefLastName.addClass('has-error');
					$checkInBookRefLastName.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$checkInBookRefLastName.removeClass('has-error');
					$checkInBookRefLastName.parent().find('.booking-form--title').removeClass('has-error');
				}
			}

			let $validationContainer:any = $checkInBookRefValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$checkinError.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + this.$checkinError[i] + '</li>');
			}

			if($validationSuccess) {
				$checkInBookRefValidator.hide();($checkInBookRefNo.val().trim())
				$checkinBookrefErrorValidation.hide();
				_self.submitCheckIn("", "desktop", ((checkInBookRefNoVal.length > 6) ? "ETKT" : "PNR"), $checkInBookRefLastName.val(), $checkInBookRefNo.val());
			} else {
				$checkInBookRefValidator.show();
			}
		});

		//Check-in Booking reference Submit Button
		$mobCheckInBookRefSubmitBtn.click((evt:any) => {
			let _self = this;
			evt.preventDefault();
			adobeDataLayer.push('click', {
                'clickName': 'click:btn-click:check-in-submit',
                'componentType': 'btn',
                'componentName': 'Check In Submit',
                'componentID': '',
				'attributes': []
            });
			let $validationSuccess    : any = true;
			let $checkinBookrefErrorValidation: any = $('.checkin-bookingref--error---validation');
			let $checkInBookRefPOD: any = $('.mobCheckin-refno--departure');
			let $checkInBookRefNo: any = $('.mobcheck-in--refno');
			let $checkInBookRefLastName: any = $('.mobcheckin-refno--lastname');
			let $checkInBookRefValidator : any = $('.checkin-bookingref--validator');
			_self.$checkinError = [];
			$checkinBookrefErrorValidation.show();
			
			/** validate Booking Ref no. */
			let checkInBookRefNoVal = $checkInBookRefNo.val().trim();

			if(!$mobCheckInBookRefNo.parent().hasClass('disableEle')){

				if(checkInBookRefNoVal == ''){
					let $checkInBookRefNoValidate:any = $checkInBookRefNo.attr('data-bookrefno');
					_self.$checkinError.push('<strong>'+$checkInBookRefNo.parent().find('label').text()+':</strong> '+$checkInBookRefNoValidate);
					$checkInBookRefNo.addClass('has-error');
					$checkInBookRefNo.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else if(
					!ticketNoLimits.includes(checkInBookRefNoVal.length) 
						|| (checkInBookRefNoVal.length == 14 && !eticketNumberPattern.test(checkInBookRefNoVal))						
				) {
					let $checkInBookRefNoValidate:any = $checkInBookRefNo.attr('data-eticketnolen');
					_self.$checkinError.push('<strong>'+$checkInBookRefNo.parent().find('label').text()+':</strong> '+$checkInBookRefNoValidate);
					$checkInBookRefNo.addClass('has-error');
					$checkInBookRefNo.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else {
					$checkInBookRefNo.removeClass('has-error');
					$checkInBookRefNo.parent().find('.booking-form--title').removeClass('has-error');
				}

				/** validate Booking Last Name */
				if($checkInBookRefLastName.val() == ''){
					let $checkInBookRefLastNameValidate:any = $checkInBookRefLastName.attr('data-checkinlastname');
					_self.$checkinError.push('<strong>'+$checkInBookRefLastName.parent().find('label').text()+':</strong> '+$checkInBookRefLastNameValidate);
					$checkInBookRefLastName.addClass('has-error');
					$checkInBookRefLastName.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$checkInBookRefLastName.removeClass('has-error');
					$checkInBookRefLastName.parent().find('.booking-form--title').removeClass('has-error');
				}
			}

			let $validationContainer:any = $checkInBookRefValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$checkinError.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + this.$checkinError[i] + '</li>');
			}

			if($validationSuccess) {
				$checkInBookRefValidator.hide();
				$checkinBookrefErrorValidation.hide();
				_self.submitCheckIn("", "mobile", ((checkInBookRefNoVal.length > 6) ? "ETKT" : "PNR"), $checkInBookRefLastName.val(), $checkInBookRefNo.val());
			} else {
				$checkInBookRefValidator.show();
			}
		});
	}

	// Check-in IBE - eticket no.
	checkinEticketNo(): void {
		let _self = this;
		let $checkInEticketSubmitBtn: any = $('.checkInEticketSubmit');
		let $mobCheckInEticketSubmitBtn: any = $('.mobcheckin-eticket--btn');

		$('.eticket-no').click(() =>{
			_self.$bookRefContainer.hide();
			_self.$eTicketContainer.show();
			_self.$scope.find('.checkin-list li').removeClass('selected');
			_self.$scope.find('.eticket-no').parent().addClass('selected');
		});

		$('#mob-checkin--container .eticket-no').click(() =>{
			_self.$bookRefContainer.hide();
			_self.$eTicketContainer.show();
			_self.$scopeMob.find('.checkin-list li').removeClass('selected');
			_self.$scopeMob.find('.eticket-no').parent().addClass('selected');
		});

		let $checkInEticketNo: any = $('.check-in--eticketno');
		let $checkInEticketLastName: any = $('.checkin-eticket--lastname');
		let $checkInEticketDeparture: any = $('.checkin-eticket--departure');
		let $eticketBookrefDate: any = $('.eticket-bookref--date');
		$checkInEticketDeparture.parent().addClass('disableEle');
		$eticketBookrefDate.parent().addClass('disableEle');

		let $mobCheckInEticketNo: any = $('.mobcheck-in--eticketno');
		let $mobCheckInEticketLastName: any = $('.mobcheckin-eticket--lastname');
		let $mobCheckInEticketDeparture: any = $('.mobCheckin-eticket--departure');
		let $mobEticketBookRefDate: any = $('.mob-eticket-bookref--date');
		$mobCheckInEticketDeparture.parent().addClass('disableEle');
		$mobEticketBookRefDate.parent().addClass('disableEle');

		//Check-in ETicket Submit Button
		$checkInEticketSubmitBtn.click((evt:any) => {
			let _self = this;
			evt.preventDefault();
			let $validationSuccess    : any = true;
			let $checkInEticketPOD: any = $('.checkin-eticket--departure');
			let $checkInEticketNo: any = $('.check-in--eticketno');
			let $checkInEticketLastName: any = $('.checkin-eticket--lastname');
			let $checkInEticketValidator : any = $('.checkinEticket-validator');
			let $checkinEticketErrorValidation: any = $('.checkin-eticketnos--error---validation');

			_self.$checkinError = [];
			$checkinEticketErrorValidation.show();

			if(!$checkInEticketNo.parent().hasClass('disableEle')){
				/** validate Eticket no. */
				let ticketNoLimits = [6,13];
				if($checkInEticketNo.val() == ''){
					let $checkInEticketNoValidate:any = $checkInEticketNo.attr('data-eticketno');
					_self.$checkinError.push('<strong>'+$checkInEticketNo.parent().find('label').text()+':</strong> '+$checkInEticketNoValidate);
					$checkInEticketNo.addClass('has-error');
					$checkInEticketNo.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else if(!ticketNoLimits.includes($checkInEticketNo.val().length)) {
					let $checkInEticketNoValidate:any = $checkInEticketNo.attr('data-eticketnolen');
					_self.$checkinError.push('<strong>'+$checkInEticketNo.parent().find('label').text()+':</strong> '+$checkInEticketNoValidate);
					$checkInEticketNo.addClass('has-error');
					$checkInEticketNo.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$checkInEticketNo.removeClass('has-error');
					$checkInEticketNo.parent().find('.booking-form--title').removeClass('has-error');
				}

				/** validate Booking Last Name */
				if($checkInEticketLastName.val() == ''){
					let $checkInEticketLastNameValidate:any = $checkInEticketLastName.attr('data-checkinlastname');
					_self.$checkinError.push('<strong>'+$checkInEticketLastName.parent().find('label').text()+':</strong> '+$checkInEticketLastNameValidate);
					$checkInEticketLastName.addClass('has-error');
					$checkInEticketLastName.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$checkInEticketLastName.removeClass('has-error');
					$checkInEticketLastName.parent().find('.booking-form--title').removeClass('has-error');
				}
			}

			let $validationContainer:any = $checkInEticketValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$checkinError.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + this.$checkinError[i] + '</li>');
			}

			if($validationSuccess) {
				$checkInEticketValidator.hide();
				$checkinEticketErrorValidation.hide();
				console.log('Success');
				_self.submitCheckIn("", "desktop", "ETKT", $checkInEticketLastName.val(), $checkInEticketNo.val());

			} else{
				$checkInEticketValidator.show();
			}
		});

		$mobCheckInEticketSubmitBtn.click((evt:any) => {
			let _self = this;
			evt.preventDefault();
			let $validationSuccess    : any = true;
			let $checkInEticketPOD: any = $('.mobCheckin-eticket--departure');
			let $checkInEticketNo: any = $('.mobcheck-in--eticketno');
			let $checkInEticketLastName: any = $('.mobcheckin-eticket--lastname');
			let $checkInEticketValidator : any = $('.checkin-eticketnos--validator');
			let $checkinEticketErrorValidation: any = $('.checkin-eticketnos--error---validation');

			_self.$checkinError = [];
			$checkinEticketErrorValidation.show();

			if(!$mobCheckInEticketNo.parent().hasClass('disableEle')){
				/** validate Eticket no. */
				if($checkInEticketNo.val() == '') {
					let $checkInEticketNoValidate:any = $checkInEticketNo.attr('data-eticketno');
					_self.$checkinError.push('<strong>'+$checkInEticketNo.parent().find('label').text()+':</strong> '+$checkInEticketNoValidate);
					$checkInEticketNo.addClass('has-error');
					$checkInEticketNo.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else if($checkInEticketNo.val().length != 6 || $checkInEticketNo.val().length != 13) {
					let $checkInEticketNoValidate:any = $checkInEticketNo.attr('data-eticketnolen');
					_self.$checkinError.push('<strong>'+$checkInEticketNo.parent().find('label').text()+':</strong> '+$checkInEticketNoValidate);
					$checkInEticketNo.addClass('has-error');
					$checkInEticketNo.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else {
					$checkInEticketNo.removeClass('has-error');
					$checkInEticketNo.parent().find('.booking-form--title').removeClass('has-error');
				}

				/** validate Booking Last Name */
				if($checkInEticketLastName.val() == ''){
					let $checkInEticketLastNameValidate:any = $checkInEticketLastName.attr('data-checkinlastname');
					_self.$checkinError.push('<strong>'+$checkInEticketLastName.parent().find('label').text()+':</strong> '+$checkInEticketLastNameValidate);
					$checkInEticketLastName.addClass('has-error');
					$checkInEticketLastName.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else{
					$checkInEticketLastName.removeClass('has-error');
					$checkInEticketLastName.parent().find('.booking-form--title').removeClass('has-error');
				}
			}

			let $validationContainer:any = $checkInEticketValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$checkinError.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + this.$checkinError[i] + '</li>');
			}

			if($validationSuccess) {
				$checkInEticketValidator.hide();
				$checkinEticketErrorValidation.hide();
				console.log('Success');
				_self.submitCheckIn("", "mobile", "ETKT", $checkInEticketLastName.val(), $checkInEticketNo.val());
			} else{
				$checkInEticketValidator.show();
			}
		});
	}

	getNextThreeDays(): void {
		let _self = this;
		let $dateRangeCheckIn:any = document.getElementById('checkin-bookrefDate');
		let $mobDateRangeCheckIn:any = document.getElementById('mobCheckin-bookrefDate');
		let $monthNames:any = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

		for(let $day:any = 0; $day < 3; $day++) {
			let $date:any = new Date();
			$date.setDate($date.getDate() + $day);

			let displayDateValue:string = moment($date).format('DD MMM YYYY');
			let actualDateValue:string = moment(displayDateValue, 'DD MMM YYYY').toISOString(); // do it like this to get rid of the time value (reset to 00:00)

			$dateRangeCheckIn.options[$dateRangeCheckIn.options.length] = new Option(displayDateValue, actualDateValue);
			$mobDateRangeCheckIn.options[$mobDateRangeCheckIn.options.length] = new Option(displayDateValue, actualDateValue);
		}

		$('#checkin-bookrefDate').selectize({
					onInitialize: function() {
						_self.wcag.selectizeInputAria($('#checkin-bookrefDate')[0].selectize);
					}
		});

		$('#mobCheckin-bookrefDate').selectize({
					onInitialize: function() {
						_self.wcag.selectizeInputAria($('#mobCheckin-bookrefDate')[0].selectize);
					}
		});

		$('.checkInDateBook .booking-form--title').addClass('input-filled');
		$('.checkInDateBook .selectize-control.single .selectize-input').addClass('select-filled');
		$('.checkInDateBook .selectize-input input').attr('readonly','readonly');
	}

	initSelectize(listItems:any): void {
		let _self = this;
		$('.checkin-refno--departure').html(listItems);
		$('.checkin-refno--departure').selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($('.checkin-refno--departure')[0].selectize);
			},
			onFocus: function() {
				$('.pointofDeparture .booking-form--title').addClass('input-filled');
				$('.pointofDeparture .selectize-control.single .selectize-input').addClass('select-filled');
				$('select.checkin-refno--departure').parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$('select.checkin-refno--departure').parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function() {
				$('.pointofDeparture .booking-form--title').addClass('input-filled');
				$('.pointofDeparture .selectize-control.single .selectize-input').addClass('select-filled');
				$('.checkinRefNo-error--validation').hide();
				let $getVar = $('.checkin-refno--departure')[0].selectize.getValue();
				// if (_self.isAmadeusAirport($getVar)) {
					 $('.checkInPnr').removeClass('disableEle');
					 $('.checkInLastName').removeClass('disableEle');
					 $('.checkinRefNo-error--validation').removeClass('disableValidate');
				 // } else{
					//  $('.checkInPnr').addClass('disableEle');
					//  $('.checkInLastName').addClass('disableEle');
					//  $('.checkInPnr .booking-form--title, .checkInLastName .booking-form--title').removeClass('has-error');
					//  $('.check-in--refno, .checkin-refno--lastname').removeClass('has-error');
				 // }
			},
			onBlur: function(){
				let $fromLocationChange = $(".checkin-refno--departure option:selected").text();
				if($fromLocationChange == ''){
					$('.pointofDeparture .booking-form--title').removeClass('input-filled');
					$('.pointofDeparture .selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$('.pointofDeparture .booking-form--title').addClass('input-filled');
					$('.pointofDeparture .selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			selectOnTab: true
		});

		$('.checkin-eticket--departure').html(listItems);
		$('.checkin-eticket--departure').selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($('.checkin-eticket--departure')[0].selectize);
			},
			onFocus: function() {
				$('.eTicketPOD .booking-form--title').addClass('input-filled');
				$('.eTicketPOD .selectize-control.single .selectize-input').addClass('select-filled');
				$('select.checkin-eticket--departure').parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$('select.checkin-eticket--departure').parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function() {
				$('.eTicketPOD .booking-form--title').addClass('input-filled');
				$('.eTicketPOD .selectize-control.single .selectize-input').addClass('select-filled');
				$('.checkinEticket-error--validation').hide();
				let $getVar = $('.checkin-eticket--departure')[0].selectize.getValue();
				// if (_self.isAmadeusAirport($getVar)) {
					$('.eTicketNo').removeClass('disableEle');
					$('.eTicketLastName').removeClass('disableEle');
					$('.checkinEticket-error--validation').removeClass('disableValidate');
				// } else{
				// 	$('.eTicketNo').addClass('disableEle');
				// 	$('.eTicketLastName').addClass('disableEle');
				// 	$('.eTicketNo .booking-form--title, .eTicketLastName .booking-form--title').removeClass('has-error');
				// 	$('.check-in--eticketno, .checkin-eticket--lastname').removeClass('has-error');
				// }
			},
			onBlur: function(){
				let $fromLocationChange = $(".checkin-eticket--departure option:selected").text();
				if($fromLocationChange == ''){
					$('.eTicketPOD .booking-form--title').removeClass('input-filled');
					$('.eTicketPOD .selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$('.eTicketPOD .booking-form--title').addClass('input-filled');
					$('.eTicketPOD .selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			selectOnTab: true
		});

		// desktop environment
		$('.checkin-bookRefHour, .checkin-bookRefMin, .eticket-bookRefHour, .eticket-bookRefMin').each((i:number, el:any) => {
			$(el).selectize({
				onInitialize: function() {
					_self.wcag.selectizeInputAria(el.selectize);
				}
			});
		});

		 // mobile environment
		$('.mobCheckin-time--hour, .mobCheckin-time--min, .mobCheckin-bookRefHour, .mobCheckin-bookRefMin, .mobEticket-bookRefHour, .mobEticket-bookRefMin, .mobCheckin-eTicketTime--hour, .mobCheckin-eTicketTime--min').each((i:number, el:any) => {
			$(el).selectize({
				onInitialize: function() {
					_self.wcag.selectizeInputAria(el.selectize);
				}
			});
		});

		$('.mobCheckin-refno--departure').html(listItems);
		$('.mobCheckin-refno--departure').selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($('.mobCheckin-refno--departure')[0].selectize);
			},
			onFocus: function() {
				$('.pointofDeparture .booking-form--title').addClass('input-filled');
				$('.pointofDeparture .selectize-control.single .selectize-input').addClass('select-filled');
				$('select.mobCheckin-refno--departure').parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$('select.mobCheckin-refno--departure').parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function() {
					$('.pointofDeparture .booking-form--title').addClass('input-filled');
					$('.pointofDeparture .selectize-control.single .selectize-input').addClass('select-filled');
					$('.checkinRefNo-error--validation').hide();
					let $getVar = $('.mobCheckin-refno--departure')[0].selectize.getValue();
					// if (_self.isAmadeusAirport($getVar)) {
						 $('.checkInPnr').removeClass('disableEle');
						 $('.checkInLastName').removeClass('disableEle');
						 $('.checkinRefNo-error--validation').removeClass('disableValidate');
					 // } else{
						//  $('.checkInPnr').addClass('disableEle');
						//  $('.checkInLastName').addClass('disableEle');
						//  $('.checkInPnr .booking-form--title, .checkInLastName .booking-form--title').removeClass('has-error');
						//  $('.check-in--refno, .checkin-refno--lastname').removeClass('has-error');
					 // }
					 // Revisit starts
					 // if ($getVar.indexOf('KUL')>-1) {
					 // 	$('.bookingDestination').removeClass('disableEle');
					 // 	$('.destination-info').show();
					 // }
					 // else {
					 // 	$('.bookingDestination').addClass('disableEle');
					 // 	$('.destination-info').hide();
					 // }
					 // Revisit ends

			},
			onBlur: function(){
				let $fromLocationChange = $(".mobCheckin-refno--departure option:selected").text();
				if($fromLocationChange == ''){
					$('.pointofDeparture .booking-form--title').removeClass('input-filled');
					$('.pointofDeparture .selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$('.pointofDeparture .booking-form--title').addClass('input-filled');
					$('.pointofDeparture .selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			selectOnTab: true
		});

		$('.mobCheckin-eticket--departure').html(listItems);
		$('.mobCheckin-eticket--departure').selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($('.mobCheckin-eticket--departure')[0].selectize);
			},
			onFocus: function() {
				$('.eTicketPOD .booking-form--title').addClass('input-filled');
				$('.eTicketPOD .selectize-control.single .selectize-input').addClass('select-filled');
				$('select.mobCheckin-eticket--departure').parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$('select.mobCheckin-eticket--departure').parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function() {
					$('.eTicketPOD .booking-form--title').addClass('input-filled');
					$('.eTicketPOD .selectize-control.single .selectize-input').addClass('select-filled');
					$('.checkinEticket-error--validation').hide();
					let $getVar = $('.mobCheckin-eticket--departure')[0].selectize.getValue();
					// if (_self.isAmadeusAirport($getVar)) {
						 $('.eTicketNo').removeClass('disableEle');
						 $('.eTicketLastName').removeClass('disableEle');
						 $('.checkinEticket-error--validation').removeClass('disableValidate');
					 // } else{
						//  $('.eTicketNo').addClass('disableEle');
						//  $('.eTicketLastName').addClass('disableEle');
						//  $('.eTicketNo .booking-form--title, .eTicketLastName .booking-form--title').removeClass('has-error');
						//  $('.check-in--eticketno, .checkin-eticket--lastname').removeClass('has-error');
						// }
						// Revisit starts
						// if ($getVar.indexOf('KUL')>-1) {
						// 	$('.eTicketDestination').removeClass('disableEle');
						// 	$('.destination-info').show();
						// }
						// else {
						// 	$('.eTicketDestination').addClass('disableEle');
						// 	$('.destination-info').hide();
						// }
						// Revisit ends

			},
			onBlur: function(){
				let $fromLocationChange = $(".mobCheckin-eticket--departure option:selected").text();
				if($fromLocationChange == ''){
					$('.eTicketPOD .booking-form--title').removeClass('input-filled');
					$('.eTicketPOD .selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$('.eTicketPOD .booking-form--title').addClass('input-filled');
					$('.eTicketPOD .selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			selectOnTab: true
		});
	}

	// isAmadeusAirport(airportName:string):boolean {
	// 	var segments = airportName.split(";");
	// 	if(segments[1] == 'A') {
	// 		return true;
	// 	}
	// 	return false;
	// }

	submitCheckIn(pod:string, device:string, pnrEticket:string, surname:string, identification:string): void {
		let _self = this;
		let isRefxWCIEnabled = $('#isRefxWCIEnabled').val() === 'true';
		let bcommon = _self.bcommon;
		let podStationName = pod.split(";")[0];
		let sitaDesktopUrl = $("#sitaDesktopUrl").val();
		let sitaMobileUrl = $("#sitaMobileUrl").val();
		let amadeusUrl = null;
		if(isRefxWCIEnabled) {
			amadeusUrl = $("#amadeusUrl").val();
		} else {
			amadeusUrl = $("#amadeusOldUrl").val();
		}
		// let language = $("#amadeusLanguage").val();
		let language:any = Cookies.get('session-selected-language');
		let plusGradeUrl = $("#plusGradeUrl").val();
		let $enablePlusGrade: any	=	$('#enablePlusGrade');
    	bcommon.preloader();

		if(language === "ms"|| language === "my") 
		{
			if(isRefxWCIEnabled) {
				language = "ms-MY";
			} else {
				language = "MS";
			}
		} else if(language === "th") 
		{
			if(isRefxWCIEnabled) {
				language = "th-TH";
			} else {
				language = "TH";
			}
		}
		else if(language === "ar") 
		{
			language = "ar-SA";
		}
		else if(language === "tw") 
		{
			if(isRefxWCIEnabled) {
				language = "zh-Hant";
			} else {
				language = "TW";
			}
		}
		else if(language === "zh_HK") 
		{
				if(isRefxWCIEnabled) {
					language = "zh-Hant";
				} else {
					language = "TW";
				}
		}else if(language === "cn"|| language === "zh_CN") 
		{
			if(isRefxWCIEnabled) {
				language = "zh-Hans";
			} else {
				language = "CN";
			}
		}
		else if(language === "jp"|| language === "ja") 
		{
			if(isRefxWCIEnabled) {
				language = "ja-JP";
			} else {
				language = "JA";
			}
		}else if(language === "kr"|| language === "ko") 
		{
			
			language = "ko-KR";
			
		}
		else if(language === "id") 
		{
			if(isRefxWCIEnabled) {
				language = "id-ID";
			} else {
				language = "ID";
			}
		} else if(language === "vn"|| language === "vi") 
		{
			if(isRefxWCIEnabled) {
				language = "vi-VN";
			} else {
				language = "VI";
			}
		}else
		{
			if(isRefxWCIEnabled) {
				language = "en-GB";
			} else {
				language = "EN";
			}
		}
		if(isRefxWCIEnabled) {
			amadeusUrl = amadeusUrl+"?lastName="+surname+"&identifier="+identification+"&lang="+language;
		} else {
			amadeusUrl = amadeusUrl+"?ISurname="+surname+"&IFormOfIdentification="+pnrEticket+
			"&IIdentification="+identification+"&ln="+language;
		}
		identification = identification.replace('-', '');
		if(podStationName.indexOf("KUL") == -1) {
			if (_self.validateTheDateTimeValues(pod, pnrEticket,device)) {
				if ((pnrEticket == 'PNR') && ($enablePlusGrade.val()!='null') && ($enablePlusGrade.val()!='0') && ($enablePlusGrade.val()!='')) {					
					plusGradeUrl = plusGradeUrl+"?lastName="+surname+
					"&pnr="+identification +"&callbackUrl="+ amadeusUrl;
					window.location.href = plusGradeUrl;
				}
				else {
				// amadeusUrl = amadeusUrl+"?ISurname="+surname+"&IFormOfIdentification="+pnrEticket+
				// "&IIdentification="+identification+"&ln="+language;
					window.location.href = amadeusUrl;
				}
			} else {
				if(device == 'mobile') {
					window.location.href = sitaMobileUrl;
				} else {
					window.location.href = sitaDesktopUrl;
				}
			}
		} else {
			if (_self.validateTheDateTimeValues(pod, pnrEticket,device)) {

				if ((pnrEticket == 'PNR') && ($enablePlusGrade.val()!='null') && ($enablePlusGrade.val()!='0') && ($enablePlusGrade.val()!='')) {					
					plusGradeUrl = plusGradeUrl+"?lastName="+surname+
					"&pnr="+identification +"&callbackUrl="+ amadeusUrl;
					window.location.href = plusGradeUrl;
				}
				else{
					// amadeusUrl = amadeusUrl+"?ISurname="+surname+"&IFormOfIdentification="+pnrEticket+
					// "&IIdentification="+identification+"&ln="+language;
					window.location.href = amadeusUrl;
				}
				
			} else {
				if(device == 'mobile') {
					window.location.href = sitaMobileUrl;
				} else {
					window.location.href = sitaDesktopUrl;
				}
			}
		}
			bcommon.preloaderClose();
	}

	checkinValidateTimeWithAmadeus(date:any, hr:number, min:number, openTime:string): any {
    // clean time
    var vhr   = hr < 10 ? '0'+hr : hr;
    var vmin  = min < 10 ? '0'+min : min;
    // stringify date
    var datestring = date+' '+vhr+':'+vmin;
    var parseddate = Date.parse(datestring);

    console.log(datestring, parseddate);

    // compare with time
    var opentime = Date.parse(openTime);
    var timelimit = 1000 * 60 * 60 * 48;
    var timeoffset = opentime - parseddate;

    var withinLimit = Boolean(/*(timeoffset <= timelimit) ||*/ (timeoffset <= 0));

    console.log(withinLimit);

    return withinLimit;
	}

	validateTheDateTimeValues(airport:string, pnrEticket:string, device:string): any {
		// let _self = this;
		// let valid = false;
		// let airportTime = airport.split(";")[2];
		// let date,hour,min;

		// if (pnrEticket == "PNR") {
		// 	date = $("#checkin-bookrefDate").val();
		// 	hour = $(".checkin-bookRefHour").val();
		// 	min = $(".checkin-bookRefMin").val();
		// } else {
		// 	date = $("#eticket-bookrefDate").val();
		// 	hour = $(".eticket-bookRefHour").val();
		// 	min = $(".eticket-bookRefMin").val();
		// }

		// if (device == "mobile") {
		// 	if(pnrEticket == "PNR") {
		// 		date = $("#mobCheckin-bookrefDate").val();
		// 		hour = $(".mobCheckin-bookRefHour").val();
		// 		min = $(".mobCheckin-bookRefMin").val();
		// 	} else {
		// 		date = $("#mobEticket-bookrefDate").val();
		// 		hour = $(".mobEticket-bookRefHour").val();
		// 		min = $(".mobEticket-bookRefMin").val();
		// 	}
		// }

		// valid = _self.checkinValidateTimeWithAmadeus(_self.convertTheDateFromDropDown(date), hour, min, airportTime);
		// return valid;
		return true;
	}

	convertTheDateFromDropDown(date:any): string {
		let dateValue = new Date(date)+"";
		let splitDate = dateValue.split(" ")[2];
		let month = dateValue.split(" ")[1];
		let year = dateValue.split(" ")[3];
		return splitDate+" "+month+" "+year;
	}

	/**
	 * pre-populate ibe on load with data attached via data-attributes
	 * for both desktop and mobile ibe
	 * @author dominic <dominic.gan@mirumagency.com>
	 *
	 * @param {ibeCheckinData} data
	 * @param {any}         instance
	 */
	populateOnload(data:ibeCheckinData, instance:any): void {
		console.log('pop chk', data, instance);

		// populate desktop & mobile ibe
		// same field classnames so same method is okay

		switch (data.bookType) {
			case 'B':
			case 'bookingref':
				let $bookRefLink = instance.find('.checkin-list .booking-refno');
				$bookRefLink.click();

				// book ref from location
				let $bFromLocInput:any;
				if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
					$bFromLocInput = instance.find('select.checkin-refno--departure')[0].selectize;
				} else {
					$bFromLocInput = instance.find('select.mobCheckin-refno--departure')[0].selectize;
				}
				$bFromLocInput.setValue(data.fromLoc);

				// book ref check in date
				// format value to isostring before passing in
				if (data.checkinDate !== undefined && data.checkinDate.length > 0) {
					let $bCheckInDateInput = instance.find('[name="checkInDateBook"]')[0].selectize;
					let parsedCheckinDateVal = moment(data.checkinDate, 'YYYYMMDD').toISOString();
					console.log(parsedCheckinDateVal);
					$bCheckInDateInput.setValue(parsedCheckinDateVal);
				}

				// book ref no
				let $bTicketNo:any;
				if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
					$bTicketNo = instance.find('.check-in--refno');
				} else {
					$bTicketNo = instance.find('.mobcheck-in--refno');
				}
				if (data.bookRef !== undefined) {
					$bTicketNo.val(data.bookRef).blur();
				}

				// last name
				let $bLastName:any;
				if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
					$bLastName = instance.find('.checkin-refno--lastname');
				} else {
					$bLastName = instance.find('.mobcheckin-refno--lastname');
				}
				if (data.lastName !== undefined) {
					$bLastName.val(decodeURI(data.lastName)).blur();
				}

				break;
			case 'E':
			case 'eticket':
				let $eticketLink = instance.find('.checkin-list .eticket-no');
				$eticketLink.click();

				// eticket from location
				let $eFromLocInput:any;
				if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
					$eFromLocInput = instance.find('select.checkin-eticket--departure')[0].selectize;
				} else {
					$eFromLocInput = instance.find('select.mobCheckin-eticket--departure')[0].selectize;
				}
				$eFromLocInput.setValue(data.fromLoc);

				// eticket check in date
				// format value to isostring before passing in
				if (data.checkinDate !== undefined && data.checkinDate.length > 0) {
					let $eCheckInDateInput = instance.find('[name="checkInDateEticket"]')[0].selectize;
					let parsedCheckinDateVal = moment(data.checkinDate, 'YYYYMMDD').toISOString();
					console.log(parsedCheckinDateVal);
					$eCheckInDateInput.setValue(parsedCheckinDateVal);
				}

				// eticket number
				let $eTicketNoInput:any;
				if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
					$eTicketNoInput = instance.find('.check-in--eticketno');
				} else {
					$eTicketNoInput = instance.find('.mobcheck-in--eticketno');
				}
				if (data.bookRef !== undefined) {
					$eTicketNoInput.val(data.bookRef).blur();
				}

				// last name
				let $eLastNameInput:any;
				if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
					$eLastNameInput = instance.find('.checkin-eticket--lastname');
				} else {
					$eLastNameInput = instance.find('.mobcheckin-eticket--lastname');
				}
				if (data.lastName !== undefined) {
					$eLastNameInput.val(decodeURI(data.lastName)).blur();
				}

				break;
			default:
				break;
		}
	}

	/**
	 * parse url params to detect check in deep link
	 * open and populate with params
	 * ?ibe=chk&bookType=ABC&fromLoc=ABC&checkinDate=ABC&bookRef=ABC&lastName=ABC
	 */
	deeplink():void {
		let _self = this;
		let bcommon = _self.bcommon;

		let urlParams = bcommon.getUrlVars(window.location.href);

		if (urlParams.ibe && urlParams.ibe === 'chk') {

			// parse url params into ibeCheckinData object
			let chkData:ibeCheckinData = {};

			chkData.bookType = urlParams.bookType;
			chkData.fromLoc = urlParams.fromLoc;
			chkData.checkinDate = urlParams.checkinDate;
			chkData.bookRef = urlParams.bookRef;
			chkData.lastName = urlParams.lastName;

			const topNavIbe = $('.desktop#mab-bookingnav #check-in--container');
			const mobNavIbe = $('.mobile#mab-bookingnav #mob-checkin--container');

			// expand desktop ibe
			if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
				let $ibeNav:any;
				if($('.ibe-refresh').length >0) {
					$ibeNav = $('.desktop #bookingNav');
				}
				else {
					$ibeNav = $('#bookingNav');
				}
				
				$ibeNav.find('.check-in').click();
				$ibeNav.find('.check-in').parent().addClass('selected');
				topNavIbe.show();
				_self.populateOnload(chkData, topNavIbe);
			} else {
				// expand mobile ibe
				let $ibeNavList: any = $('#bookingNav li');
	      $ibeNavList.find('.mobile-check-in').parent().addClass('selected');
	      mobNavIbe.show();
				_self.populateOnload(chkData, mobNavIbe);
			}
		}


	}
}

let scope:Element = document.querySelector('#check-in--container');
if (scope){
	try {
		let bookingformcommon = new bookingFormCommon();
		let checkinform = new checkInForm();
		var adobeDataLayer = new adobeDataLayerWrapper();
				//checkinform.getNextThreeDays();
				checkinform.checkinBookRefNo();
				checkinform.checkinEticketNo();
				//checkinform.init();
				// $.when(window['ibeOnDList']).done((listData: any) => {
					console.log('%cc005check%c ond done', 'background-color: yellow', 'background-color: initial');
					// let listItems:string = bookingformcommon.parseOnDListItems(listData, 'wci');
					// checkinform.initSelectize(listItems);
					checkinform.nav();
					checkinform.deeplink();
				// });
	} catch(e) {console.error(e);}
}
